import React, { useState } from 'react';
import { Box, Container, Typography, Paper, Grid } from '@mui/material';
import TaskList from './components/TaskList';
import AddTask from './components/AddTask';
import MentalDeclutter from './components/MentalDeclutter';
import { Task } from './types';

function App() {
  const [tasks, setTasks] = useState<Task[]>([]);

  const handleAddTask = (task: Task) => {
    setTasks([...tasks, task]);
  };

  const handleDeleteTask = (taskId: string) => {
    setTasks(tasks.filter(task => task.id !== taskId));
  };

  const handleUpdateTask = (updatedTask: Task) => {
    setTasks(tasks.map(task => task.id === updatedTask.id ? updatedTask : task));
  };

  const handleTasksExtracted = (extractedTasks: Task[]) => {
    setTasks([...tasks, ...extractedTasks]);
  };

  const getTasksByQuadrant = (quadrant: number) => {
    return tasks.filter(task => task.quadrant === quadrant);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h3" component="h1" gutterBottom align="center">
        PrioritizeIt
      </Typography>
      <Typography variant="h6" gutterBottom align="center" color="text.secondary">
        Organize your tasks using the Eisenhower Matrix
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
        <AddTask onAddTask={handleAddTask} />
        <MentalDeclutter onTasksExtracted={handleTasksExtracted} />
      </Box>

      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={6}>
          <Paper sx={{ p: 2, height: '100%', bgcolor: '#ffebee' }}>
            <Typography variant="h6" gutterBottom>
              Quadrant 1: Important & Urgent
            </Typography>
            <TaskList
              tasks={getTasksByQuadrant(1)}
              onDeleteTask={handleDeleteTask}
              onUpdateTask={handleUpdateTask}
            />
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Paper sx={{ p: 2, height: '100%', bgcolor: '#e8f5e9' }}>
            <Typography variant="h6" gutterBottom>
              Quadrant 2: Important & Not Urgent
            </Typography>
            <TaskList
              tasks={getTasksByQuadrant(2)}
              onDeleteTask={handleDeleteTask}
              onUpdateTask={handleUpdateTask}
            />
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Paper sx={{ p: 2, height: '100%', bgcolor: '#fff3e0' }}>
            <Typography variant="h6" gutterBottom>
              Quadrant 3: Not Important & Urgent
            </Typography>
            <TaskList
              tasks={getTasksByQuadrant(3)}
              onDeleteTask={handleDeleteTask}
              onUpdateTask={handleUpdateTask}
            />
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Paper sx={{ p: 2, height: '100%', bgcolor: '#e3f2fd' }}>
            <Typography variant="h6" gutterBottom>
              Quadrant 4: Not Important & Not Urgent
            </Typography>
            <TaskList
              tasks={getTasksByQuadrant(4)}
              onDeleteTask={handleDeleteTask}
              onUpdateTask={handleUpdateTask}
            />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default App; 